import React, { useState, useEffect } from "react";
import "../styles/CookieBanner.css";

const CookieBanner = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookieConsent");
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookieConsent", "accepted");
    setShowBanner(false);
  };

  const handleReject = () => {
    localStorage.setItem("cookieConsent", "rejected");
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="cookie-banner">
      <p>
        Usamos cookies para melhorar sua experiência. Ao continuar navegando, você concorda com nossa{" "}
        <a href="/privacy-policy">Política de Privacidade</a>.
      </p>
      <div className="cookie-buttons">
        <button className="accept" onClick={handleAccept}>Aceitar</button>
        <button className="reject" onClick={handleReject}>Rejeitar</button>
      </div>
    </div>
  );
};

export default CookieBanner;
